<template>
  <div >
    <!--<CPortada :pseccion="pseccion"></CPortada>-->

    <Cbarra>
        <template slot="slotTitle">Investigación</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'investigacion'}">Investigación</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal" >
            <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-01-tab" data-toggle="pill" href="#v-pills-01" role="tab" aria-controls="v-pills-01" aria-selected="true">
                            Introducción
                        </a>
                        <div class="nav-link title-call">
                            Departamentos<i class="fas fa-angle-down color8 ml-1"></i>
                        </div>
                        <a class="nav-link sub-menu" id="v-pills-03-tab" data-toggle="pill" href="#v-pills-03" role="tab" aria-controls="v-pills-03" aria-selected="false">
                            Depto. de humanidades y sistemas sociales
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-04-tab" data-toggle="pill" href="#v-pills-04" role="tab" aria-controls="v-pills-04" aria-selected="false">
                            Depto. de matemáticas aplicadas y computación
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-05-tab" data-toggle="pill" href="#v-pills-05" role="tab" aria-controls="v-pills-05" aria-selected="false">
                            Depto. de sistemas y procesos naturales
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">

                        
                        <div class="tab-pane fade show active" id="v-pills-01" role="tabpanel" aria-labelledby="v-pills-01-tab">
                            <div  v-for="(lista,key) in objTab0.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="2" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div> 
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        
                        <div class="tab-pane fade" id="v-pills-03" role="tabpanel" aria-labelledby="v-pills-03-tab">
                            <div  v-for="(lista,key) in objTab1.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="2" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div> 
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-04" role="tabpanel" aria-labelledby="v-pills-04-tab">
                            <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="2" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div> 
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-05" role="tabpanel" aria-labelledby="v-pills-05-tab">
                            <div  v-for="(lista,key) in objTab3.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="2" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div> 
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>
</template>

<script>
export default {
    name:'',
    data() {
        return {
            pseccion:'Organigrama',
            urlApi:"inicio/investigacion",

            objTema0:{
                editar:false,
                Apartado: 'INTRO',
                Realiza: 'AddTema'
            },
            objTema1:{
                editar:false,
                Apartado: 'HUMANANIDADES',
                Realiza: 'AddTema'
            },
            objTema2:{
                editar:false,
                Apartado: 'MATEMATICAS',
                Realiza: 'AddTema'
            },
            objTema3:{
                editar:false,
                Apartado: 'SISTEMAS',
                Realiza: 'AddTema'
            },
            objTab0:{
                editar:false,
                Apartado: 'INTRO',
                ListaDet: [],
            },
            objTab1:{
                editar:false,
                Apartado: 'HUMANANIDADES',
                ListaDet: [],
            },
            objTab2:{
                editar:false,
                Apartado: 'MATEMATICAS',
                ListaDet: [],
            },
            objTab3:{
                editar:false,
                Apartado: 'SISTEMAS',
                ListaDet: [],
            },
            RutaFile: '',
            RutaFileD: '',
            listIconos: [],
        }
    },
    methods: {
        iconoFiltrado(){

        },
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'INVESTIGACION',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				// this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				// this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				// this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                // this.Segurity				= res.data.segurity;
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD               = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                let newObj0 = [];
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];

               
                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'HUMANANIDADES'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'MATEMATICAS'){
                        newObj2.push(value)
                    } 
                    else if(value.Apartado == 'SISTEMAS'){
                        newObj3.push(value)
                    }
                    else if(value.Apartado == 'INTRO'){
                        newObj0.push(value)
                    }                       
                });
                if(newObj0.length > 0){
                    this.objTab0.editar = true;
                    this.objTab0.ListaDet = newObj0;
                }

                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }

                if(newObj3.length > 0){
                    this.objTab3.editar = true;
                    this.objTab3.ListaDet = newObj3;
                }
            });
        },
    },mounted() {
        window.scrollTo(0, 0);
        this.Lista();
        
    },
}
</script>

<style>

</style>